<template>
  <div class="LKMunMehReviewFourLevels">
    <div
      v-for="(level, idx) in parent.items"
      :key="level.id"
      :ref="`SubIndicator.${level.id}`"
      :class="{ 'LKMunMehReviewFourLevels__Level__Selected': $route.params.targetId === level.id }"
      class="LKMunMehReviewFourLevels__Level"
    >
      <LKMunMehReviewRow
        :ref="`Row.${idx}`"
        class="LKMunMehReviewFourLevels__Level__Row"
        :idx="getIndex(idx)"
        :item="level"
        :second-level="secondLevel"
        :read-only="disabled"
        bold
      />

      <BTextarea
        :value="getCommentForIndicator(level.id)"
        :skeleton="isUserCommentLoading(parent.id)"
        label="Комментарий к позиции оценивания"
        :disabled="disabled"
        validate="required"
        rows="1"
        style="margin-top: 16px;"
        @input="onChangedComment(level.id, $event)"
      />

      <hr class="LkMunMehReviewForm__line">

      <v-row>
        <v-col :cols="secondLevel ? 4 : 6">
          <LKMunMehReviewFourLevelsDocuments
            :value="level"
          />
        </v-col>
        <v-divider vertical class="LKMunMehReviewFourLevels__Line-vertical" />
        <v-col :cols="secondLevel ? 8 : 6">
          <LKMunMehReviewFourLevelsMarks
            :level="level"
            :disabled="disabled"
            :marks-loading="isMarksLoading"
            :second-level="secondLevel"
          />
        </v-col>
      </v-row>

      <hr class="LkMunMehReviewForm__line">
    </div>
  </div>
</template>

<script>
import BTextarea from '@/components/forms/BTextarea.vue'
import LKMunMehReviewRow from '@/views/LKMunMeh/Review/components/LKMunMehReviewRow.vue'
import LKMunMehReviewFourLevelsMarks from '@/views/LKMunMeh/Review/components/LKMunMehReviewFourLevelsMarks.vue'
import LKMunMehReviewFourLevelsDocuments from '@/views/LKMunMeh/Review/components/LKMunMehReviewFourLevelsDocuments.vue'

import { LKMunMehReviewMapper } from '@/views/LKMunMeh/Review/store'

export default {
  name: 'LKMunMehReviewFourLevels',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BTextarea,
    LKMunMehReviewRow,
    LKMunMehReviewFourLevelsMarks,
    LKMunMehReviewFourLevelsDocuments,
  },
  props: {
    munMehId: {
      type: Number,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
    parentIdx: {
      type: String,
      required: true,
    },
    disabled: Boolean,
    secondLevel: Boolean,
  },
  computed: {
    ...LKMunMehReviewMapper.mapGetters([
      'isUserMarkLoading',
      'isUserCommentLoading',
      'getCommentForIndicator',
    ]),
    isMarksLoading() {
      return this.isUserMarkLoading(this.parent.id)
    },
  },
  watch: {
    isMarksLoading(v, oV) {
      if (!v && !!oV) {
        this.scrollToTarget()
      }
    },
  },
  mounted() {
    this.scrollToTarget()
  },
  methods: {
    ...LKMunMehReviewMapper.mapMutations(['setComment']),
    scrollToTarget(_targetId) {
      const targetId = _targetId || this.$route.params?.targetId
      if (targetId) {
        const elements = this.$refs[`SubIndicator.${targetId}`]
        if (Array.isArray(elements) && elements.length > 0) {
          this.$nextTick(() => {
            setTimeout(() => elements[0].scrollIntoView(), 100)
          })
        }
      }
    },
    getIndex(idx) {
      return [this.parentIdx, idx].join('.')
    },
    validate() {
      return this.$validator.validate()
    },
    onSaved() {
      // Обновляем значения оценок в строках.
      for (let i = 0; i < this.parent.items.length; i += 1) {
        const idx = `Row.${i}`
        this.$refs[idx][0].$forceUpdate()
      }
    },
    onChangedComment(indicatorId, value) {
      this.setComment({ indicatorId, value })
    },
  },
}
</script>

<style lang="scss">
.LKMunMehReviewFourLevels {
  &__Level {
    &__Selected {
      background-color: $webflow-color-blue-light-2;
    }

    &__Row {
      // ..
    }
  }

  &__Documents {
    .link {
      color: $webflow-color-blue-dark;
      word-wrap: break-word; /* Internet Explorer 5.5+ */
      white-space: pre-wrap; /* CSS3 */
      white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
      white-space: -o-pre-wrap; /* Opera 7 */

      &:hover {
        color: $webflow-color-blue-dark-hover;
      }
    }

    .comment {
      font-size: 16px;
      color: $webflow-color-black;
    }

    .updated-at {
      font-size: 12px;
      font-style: italic;
      color: $webflow-color-blue-dark;
      text-align: right;
    }

    .logged {
      color: $webflow-color-red;
    }
  }

  &__Line-vertical {
    border-color: $webflow-color-alert-line !important;
  }

  &__Values {
    .row {
      align-items: center;
    }

    .name {
      font-size: 16px;
      color: $webflow-color-black;
    }

    .score {
      font-weight: bold;
    }
  }
}
</style>
